var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-y":"scroll"}},[_c('img',{staticClass:"downloader",attrs:{"src":_vm.download},on:{"click":_vm.downloadApp}}),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","display":"block","padding":"0 0 0 0"},attrs:{"src":"https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/landing/landing20230320.png"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1b79502","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Landing/template3.vue
// module id = null
// module chunks = 